module.exports = __webpack_public_path__ + "img/Commerce Urdu Medium.3e66602e.jpg";